import * as React from "react";
function SvgTrashFunnel(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M26 6v6h-2V6l-6-6h14l-6 6zM5 12V9h11v3h5v2H0v-2h5zm2 0h7v-1H7v1zM22.829 2L25 4.173 27.171 2h-4.342zM17 30V16h2v16H2V16h2v14h13zM7 18h2v11H7V18zm5 0h2v11h-2V18z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTrashFunnel);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
